import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

import BaseLink from '../../../../../atoms/Link';
import { AsPropType, SiteNavigationLinkPropType } from '../../../../../services/proptypes';
import { isExternalPage } from '../../../../../services/pages';
import { cleanLinkProps, sortLinks } from './Links.utils';


const propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(SiteNavigationLinkPropType).isRequired,
  linksAs: AsPropType,
};

const defaultProps = {
  linksAs: 'span',
}


function DropdownMenu({ title, options, linksAs }) {
  const sortedOptions = sortLinks(options);
  const cleanedOptions = cleanLinkProps(sortedOptions);

  return (
    <Dropdown item text={title}>
      <Dropdown.Menu>
        {cleanedOptions.map(({ title: linkTitle, as, pageType, slug, url, ...rest }) => (
          <Dropdown.Item key={linkTitle}>
            <BaseLink
              to={isExternalPage(pageType) ? url : slug}
              as={as || linksAs}
              title={linkTitle}
              internal={!isExternalPage(pageType)}
              {...rest}
            />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

export default DropdownMenu;
